module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/panel/panel-border-bottom-120.png"+" 120w",
        images: [{path: __webpack_public_path__ + "assets/images/panel/panel-border-bottom-120.png",width: 120,height: 6}],
        src: __webpack_public_path__ + "assets/images/panel/panel-border-bottom-120.png",
        toString: function(){return __webpack_public_path__ + "assets/images/panel/panel-border-bottom-120.png"},
        
        width: 120,
        height: 6
      }